import React, { Component, Text } from 'react'
import { Drawer, Button } from 'antd'
import StartNode from './Component/StartNode'
import TaskNode from './Component/TaskNode'
import ScriptNode from './Component/ScriptNode'
import ServiceNode from './Component/ServiceNode'
import EndNode from './Component/EndNode'
import JumpNode from './Component/JumpNode'
import WorkflowNode from './Component/WorkflowNode'

export default class NodeParaEdit extends Component {
    constructor(props) {
        super(props)

        this.state = {
            type: null,
            visible: false,
            placement: 'right',
            node:props.node,
            nodedata: props.nodedata,
            loading: false
        }
    }
    showDrawer = (node) => {
        if (node && node.data && node.data.type && node.data.type=="01"|| node && node.type && node.type =="01"){
            tool.sgiLogger.log("no-------------------");
            tool.sgiLogger.log(node);
            tool.sgiLogger.log(node.data.type);
            tool.sgiLogger.log(node.type);
            this.setState({ visible:false});
            return;
        }
        tool.sgiLogger.log("done-------------------");
        if (node&&node.data) this.setState({ type:node.data.type,node:node,nodedata: node.data,visible :true });
    };
    onClose = () => {
        this.setState({
            visible: false,
        });
    };
    save(e) {
        e.preventDefault();
        this.props.form.validateFields((errors, values) => {
            if (errors) {
                tool.sgiLogger.log('输入错误,请检查!!');
                return;
            }
            //所有的form表单值，等同于values
            const formData = this.props.form.getFieldsValue();
            //从表单中获取日期timeRange的值(起始时间+结束时间)是个数组
            const timeRange = formData['timeRange'];
            /*若是不限时段 日期数组就为null*/
            if (timeRange === undefined || formData['timeFlag'] === '-1') {
                formData.startDate = null;
                formData.endDate = null;
            } else if (timeRange !== undefined && formData['timeFlag'] === '1') {
                //格式化时间数组为YYYYMMDD  startDate:起始时间 endDate：结束时间          
                formData.startDate = timeRange[0].format('YYYYMMDD');
                formData.endDate = timeRange[1].format('YYYYMMDD');
            }
            //默认添加创建人
            formData.createUser = '创建人1';
            this.props.createActions.createActivity(formData);
        });
    }
    render() {
        let child;
        if (this.state.type === '06'){
            child=(<TaskNode  key={this.state.nodedata.id}  ref="taskpanel"  show={true} node={this.state.node} nodedata={this.state.nodedata} /> );
        }
        if (this.state.type === '02'){
            child=(<JumpNode  key={this.state.nodedata.id}  ref="jumppanel"  show={true} node={this.state.node} nodedata={this.state.nodedata} /> );
        }
        if (this.state.type === '03'){
            child=(<ServiceNode  key={this.state.nodedata.id}  ref="servicepanel"  show={true} node={this.state.node} nodedata={this.state.nodedata} /> );
        }
        if (this.state.type === '04'){
            child=(<ScriptNode  key={this.state.nodedata.id}  ref="scriptpanel"  show={true} node={this.state.node} nodedata={this.state.nodedata} /> );
        }
        if (this.state.type === '05'){
            child=(<WorkflowNode  key={this.state.nodedata.id}  ref="workflownode"  show={true} node={this.state.node} nodedata={this.state.nodedata} /> );
        }
        if (this.state.type === '99'){
            child=(<EndNode  key={this.state.nodedata.id}  ref="endpanel"  show={true} node={this.state.node} nodedata={this.state.nodedata} /> );
        }
        tool.sgiLogger.log(this.state);
        tool.sgiLogger.log(child);
        tool.sgiLogger.log(this.state.visible);
        return (
            <Drawer
                mask={false}
                destroyOnClose  ={true}
                title="节点参数"
                width={720}
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={this.state.visible}
                style={{
                    // height: 'calc(100% - 55px)',
                    // overflow: 'auto',
                    paddingBottom: 55,
                }}
                bodyStyle={{ // 为了标题固定
                    height: 'calc(100% - 55px)',
                    // overflow: 'auto',
                    paddingBottom: 55,
                }}
            >
            {child}
            </Drawer>
        )
    }
}



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiFlow/Workflow/NodeParaEdit.js